const SET_LEFT_NAV_PARAMS = 'SET_LEFT_NAV_PARAMS';

export const LEFT_NAV_TYPES = {
    SET_LEFT_NAV_PARAMS
};
